import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {Subject} from 'rxjs';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatCalendar, MatDatepicker } from '@angular/material/datepicker';
import {default as _rollupMoment, Moment} from 'moment';
import { IDatepickerOption } from '../../../models/IDatepickerOption';
import { FormControl } from '@angular/forms';
import moment from 'moment';

//Formats from moment.js
export const MY_FORMATS_YY = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    
  },
};


@Component({
  selector: 'ff-datepicker-year',
  templateUrl: './datepicker-year.component.html',
  styleUrls: ['./datepicker-year.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_YY},
  ],
})
export class DatepickerYearComponent implements OnInit {

  ffDatepickerHeader = FFDatepickerHeaderYY;

    /**
     * Options to configure min and max date to datepicker
     * Use the IDatepickerOption interface: { minDate: Date, maxDate: Date }
     * * @internal
    */
     @Input() options?: IDatepickerOption;

     /**
     * Options to enable ordisable the datepicker
     * * @internal
    */
    @Input() isDisabled?: boolean;

     /**
      * Return the selection updated each time the user choses a new date.
      * * @internal
     */
    @Output() selection = new EventEmitter<Date> ();
  

    //variable date that will be used as the output
    date = new Date();

    //form control to show selected date in the input
    formDate = new FormControl(moment());

    minDate : Date = new Date(0);
    maxDate : Date = new Date();

  constructor(
  ) { }

  ngOnInit() {
    if (this.options !== undefined){
      this.minDate = this.options.minDate !== undefined ? this.options.minDate : this.minDate;

      //If there is no input with maxDate parameter, maxDate will be 30 years from the present date
      if (this.options.maxDate !== undefined){
        this.maxDate = this.options.maxDate
      } else {
        this.maxDate.setFullYear(this.maxDate.getFullYear() + 30);
      }
    } else {
      this.maxDate.setFullYear(this.maxDate.getFullYear() + 30);
    }

    this.isDisabled = this.isDisabled !== undefined ? this.isDisabled : false;
  }

  ngOnChanges() {
    if (this.isDisabled){
      this.formDate.disable();
    } else {
      this.formDate.enable();
    }
  }




  //Handles year selection
  chosenYearHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
      datepicker.close();
      const ctrlValue = this.date;
      const formDate = this.formDate.value;
  
      formDate.year(normalizedYear.year())
      ctrlValue.setFullYear(normalizedYear.year());
  
      formDate.day(1);
      this.date.setDate(1);
      formDate.month(0);
      this.date.setMonth(0);
      
      this.date = ctrlValue;
  
      this.selection.emit(this.date);
      this.formDate.setValue(formDate);

  }
}



/** Custom header component for datepicker. */
@Component({
  selector: 'ff-datepicker-header',
  styles: [`
    .dp-header {
      padding: 0.5em;
      background-color: #c81414;
      color: white;
      height: 4em;
      border-radius: 4px !important;
    }

    .year-header-label {
      font-weight: 100;
      text-align: center;
      padding: 14px;
      opacity: 0.7;
    }

    .dp-year {
      margin-bottom: -9px;
      margin-top: 3px;
    }

    .month-header-label {
      font-weight: 400;
      text-align: center;
      padding: 14px;
      font-size: 1.5em;
    }

    .selector-container {
      justify-content: space-between;
      background-color: #c81414;
      border-radius: 4px;
    }

    .btn-selector {
      background-color: #c81414;
      color: white;
      width: 50%;
      border-style: none;
    }


    .btn-selector:hover {
      border: 1px solid;
      box-shadow: inset 0 0 20px rgba(255, 255, 255, .5), 0 0 20px rgba(255, 255, 255, .2);
      outline-color: rgba(255, 255, 255, 0);
      outline-offset: 15px;
      text-shadow: 1px 1px 2px #427388; 
    }


  `],
  templateUrl: '../headers/datepicker-month-year-header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FFDatepickerHeaderYY<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
      private _calendar: MatCalendar<D>, private _dateAdapter: DateAdapter<D>) {
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  //Gets year label to use it in the header
  get yearLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, 'YYYY');
  }

  //Gets month label to use it in the header
  get monthLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, 'MMMM');
  }

  previousClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
        this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1) :
        this._dateAdapter.addCalendarYears(this._calendar.activeDate, -24);
  }

  nextClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
        this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1) :
        this._dateAdapter.addCalendarYears(this._calendar.activeDate, 24);
  }


} 


